"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vueRangeForCarline = vueRangeForCarline;
exports.vueForAudiCode = vueForAudiCode;
exports.vueForPRString = vueForPRString;
exports.vueForRawData = vueForRawData;
const utils_1 = require("./utils");
const casaService_1 = require("../services/casaService");
const tedasService_1 = require("../services/tedasService");
const rangeService_1 = require("../services/rangeService");
const transformCarline_1 = require("./transformCarline");
const transformVehicle_1 = require("./transformVehicle");
function vueRangeForCarline(country, language, carlineId, resources, configs) {
    return __awaiter(this, void 0, void 0, function* () {
        const locale = (0, utils_1.buildLocale)(language, country);
        const carline = yield (0, rangeService_1.eecRanges)(carlineId, locale, configs);
        if (carline) {
            return (0, transformCarline_1.transformCarline)(carline, locale, resources);
        }
        else {
            throw Error(`missing range info in carline ${carlineId} or carline doesn't exists in market`);
        }
    });
}
function vueForAudiCode(country, language, audiCode, resources, configs) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const locale = (0, utils_1.buildLocale)(language, country);
        const config = yield (0, casaService_1.getConfigurations)(audiCode, locale, configs);
        if (((_a = config.configurationDetails) === null || _a === void 0 ? void 0 : _a.vue) !== undefined) {
            const vue = (_b = config.configurationDetails) === null || _b === void 0 ? void 0 : _b.vue;
            if ((vue.hasNedc || vue.hasWltp) && vue.hasWltp && vue.fuels !== undefined && vue.fuels.length > 0) {
                return (0, transformVehicle_1.transformVehicleByVuE)(vue, locale, resources);
            }
            else {
                // FAM-265 - Workaround for markets without VuE-Values. Delivered by MediaEdit
                return (0, transformVehicle_1.transformVehicleByTechData)(config.configurationDetails, locale, resources);
            }
        }
        else {
            throw Error(`missing vue info in configuration ${audiCode}`);
        }
    });
}
function vueForPRString(country, language, prString, resources, configs) {
    return __awaiter(this, void 0, void 0, function* () {
        const locale = (0, utils_1.buildLocale)(language, country);
        const vue = yield (0, tedasService_1.efficiencyDataByPrString)(prString, locale, configs);
        if (vue !== undefined) {
            return (0, transformVehicle_1.transformVehicleByVuE)(vue, locale, resources);
        }
        else {
            throw Error(`missing vue info in configuration ${prString}`);
        }
    });
}
function vueForRawData(country, language, rawData, resources) {
    const locale = (0, utils_1.buildLocale)(language, country);
    return (0, transformVehicle_1.transformVehicleByVuE)(rawData, locale, resources);
}
